/* eslint-disable */
// HISTÓRICO CONGELADO de F3c (calculateVentas): copia literal del código anterior de cartelería de src/utils/calculateVentas.js. Producción lo usa para los meses < 2026-10 (corteHistorico.js). No editar.
import { getMesesAFacturar } from "../../carteleriaFacturacion";
import { loadExchangeRates, convertirAMonedaLocal } from "../../exchangeRateService";

// Fecha de facturación de un mes desde `negocios_carteleria.meses_facturacion` — MISMA fuente/fecha
// que BRUTO (useVFDataLoading: `mesFact.facturafecha`). `tipo`: "gestion" | "opex". Se usa para que la
// conversión UF/USD de Proyección caiga en la MISMA fecha que la grilla de Facturación cuando NO hay
// registro en costos_gestion_contenidos, en vez del viejo fallback a fin de mes (divergencia diagnosticada).
const getFacturafechaMesesFact = (negocio, tipo, mesIndex, ano) => {
  const mf =
    typeof negocio.meses_facturacion === "string"
      ? JSON.parse(negocio.meses_facturacion || "[]")
      : negocio.meses_facturacion || [];
  if (!Array.isArray(mf)) return null;
  const mesStr = String(mesIndex + 1).padStart(2, "0");
  const anoStr = String(ano);
  const rec = mf.find((x) => x && x.tipo === tipo && x.mes === mesStr && x.ano === anoStr);
  return rec?.facturafecha || null;
};

/**
 * Calcula ingresos mensuales de HARDWARE (facturación)
 * Extraído del ER - lógica exacta con CAPEX/OPEX
 * @param {number} ano - Año a calcular
 * @param {Array} negociosCarteleria - Array de negocios cartelería
 * @param {string} pais - "Chile" o "Perú"
 * @param {Array} costosGestionData - Datos de costos gestión (para fechas factura OPEX)
 * @returns {Array<number>} Array(12) con ingresos por mes
 */
export const calcularHardwareMensual = async (ano, negociosCarteleria, pais, costosGestionData = []) => {
  await loadExchangeRates();

  const mapa = Array(12).fill(0);

  negociosCarteleria.forEach((n) => {
    if (!n.incluye_hardware || n.eliminada) return;
    if (!["100%", "Activo"].includes(n.estado)) return;

    const moneda = (n.moneda_hardware || "UF").toUpperCase();
    let yaProcesadoConDesglose = false;

    // === CAPEX CON DESGLOSE DE PAGOS ===
    // Mes de FACTURACIÓN del tramo (dimensión devengo, 10.143), cascada de proyección: 1) fecha real
    // (`facturafecha` del modal || `fecha_factura` legacy); 2) `fecha_factura_estimada` del tramo
    // (estimación de facturación del saldo pendiente); 3) `fecha_cierre` como fallback para tramos viejos
    // sin el campo estimado. `fecha_cobro_estimada` NO participa: es dato de cobro (Caja), no ubica
    // facturación (10.143). Así el saldo pendiente se ubica en su mes esperado en vez de desaparecer.
    const detalleCapex = Array.isArray(n.detalle_pagos_hardware) ? n.detalle_pagos_hardware : [];
    if (n.modalidad === "CAPEX" && detalleCapex.length > 0) {
      detalleCapex.forEach((pago) => {
        const fechaTramo = pago.facturafecha || pago.fecha_factura || pago.fecha_factura_estimada || n.fecha_cierre;
        if (!fechaTramo || pago.monto == null) return;

        const fecha = new Date(fechaTramo);
        const mes = fecha.getMonth();
        const año = fecha.getFullYear();

        if (año !== ano) return;

        const monto = Number(pago.monto);
        const fechaUsada = fechaTramo.split("T")[0];

        mapa[mes] += convertirAMonedaLocal(monto, moneda, pais, fechaUsada);
      });
      yaProcesadoConDesglose = true;
    }

    // === OTROS CAPEX (instalación, etc.) ===
    if (
      n.modalidad === "CAPEX" &&
      n.detalle_otros_hardware &&
      Array.isArray(n.detalle_otros_hardware) &&
      n.detalle_otros_hardware.length > 0
    ) {
      n.detalle_otros_hardware.forEach((pago) => {
        if (!pago.fecha_factura || pago.monto == null) return;

        const fecha = new Date(pago.fecha_factura);
        const mes = fecha.getMonth();
        const año = fecha.getFullYear();

        if (año !== ano) return;

        const monto = Number(pago.monto);
        const fechaUsada = pago.fecha_factura.split("T")[0];

        mapa[mes] += convertirAMonedaLocal(monto, moneda, pais, fechaUsada);
      });
    }

    // === CAPEX SIN DESGLOSE ===
    if (n.modalidad === "CAPEX" && n.fecha_cierre && !yaProcesadoConDesglose) {
      const fechaCierre = new Date(n.fecha_cierre);
      const mesCierre = fechaCierre.getMonth();
      const añoCierre = fechaCierre.getFullYear();

      if (añoCierre !== ano) return;

      const monto = Number(n.monto_hardware) || 0;
      const ultimoDia = new Date(ano, mesCierre + 1, 0);
      const fechaStr = ultimoDia.toISOString().split("T")[0];

      mapa[mesCierre] += convertirAMonedaLocal(monto, moneda, pais, fechaStr);
    }

    // === OPEX (cuotas mensuales) ===
    else if (n.modalidad === "OPEX" && n.cuota_hardware_opex && n.fecha_cierre) {
      const fechaCierre = new Date(n.fecha_cierre);
      const mesCierre = fechaCierre.getMonth();
      const añoCierre = fechaCierre.getFullYear();

      const pantallas = Number(n.cantidad_pantallas) || 1;
      const cuotaBase = Number(n.cuota_hardware_opex);
      const totalCuotas = Number(n.num_cuotas) || Number(n.plazo_contrato_meses) || 36;

      let cuotaActual = 0;
      let añoActual = añoCierre;
      let mesActual = mesCierre;

      while (cuotaActual < totalCuotas) {
        if (añoActual === ano && mesActual >= 0 && mesActual < 12) {
          // Fecha para convertir UF/USD, con la MISMA prioridad de fecha que BRUTO cuando falta el
          // registro de costos: 1) costos_gestion_contenidos.fecha_factura (dato real de costo, se
          // preserva); 2) meses_facturacion[opex].facturafecha (misma fecha que useVFDataLoading);
          // 3) día 1 del mes (mismo fallback que BRUTO). NUNCA fin de mes como default fijo.
          const registro = costosGestionData.find(
            (c) =>
              Number(c.negocio_id) === n.id &&
              Number(c.mes) === mesActual + 1 &&
              Number(c.ano) === ano &&
              c.fecha_factura
          );

          const primerDiaMes = `${ano}-${String(mesActual + 1).padStart(2, "0")}-01`;
          const fechaFactura =
            registro?.fecha_factura?.split("T")[0] || getFacturafechaMesesFact(n, "opex", mesActual, ano) || primerDiaMes;

          const cuotaLocal = cuotaBase * pantallas;
          mapa[mesActual] += convertirAMonedaLocal(cuotaLocal, moneda, pais, fechaFactura);
        }

        cuotaActual++;
        mesActual++;
        if (mesActual >= 12) {
          mesActual = 0;
          añoActual++;
        }
        if (añoActual > ano + 1) break;
      }
    }
  });

  return mapa;
};

/**
 * Calcula ingresos mensuales de GESTIÓN Y CONTENIDOS (facturación)
 * Extraído del ER - lógica exacta
 * @param {number} ano - Año a calcular
 * @param {Array} negociosCarteleria - Array de negocios cartelería
 * @param {string} pais - "Chile" o "Perú"
 * @param {Array} costosGestionData - Datos de costos gestión (para fechas factura)
 * @returns {Array<number>} Array(12) con ingresos por mes
 */
export const calcularGestionContenidosMensual = async (ano, negociosCarteleria, pais, costosGestionData = []) => {
  await loadExchangeRates();

  const mapa = Array(12).fill(0);

  negociosCarteleria.forEach((negocio) => {
    if (negocio.eliminada || negocio.estado !== "Activo" || !negocio.fecha_inicio) return;

    const plazoMeses = parseInt(negocio.plazo_contrato_meses) || 0;
    if (plazoMeses === 0) return;

    const pantallas = parseInt(negocio.cantidad_pantallas) || 1;
    const gestionUnitario = parseFloat(negocio.fee_gestion_unitario) || 0;
    const contenidosUnitario = negocio.incluye_contenidos ? parseFloat(negocio.fee_contenidos_unitario) || 0 : 0;

    const getFechaFactura = (mesIndex) => {
      const registro = costosGestionData.find(
        (c) =>
          Number(c.negocio_id) === negocio.id &&
          Number(c.mes) === mesIndex + 1 &&
          Number(c.ano) === ano &&
          c.fecha_factura
      );
      return registro?.fecha_factura?.split("T")[0] || null;
    };

    // Ventana de meses = MISMO criterio que BRUTO (getMesesAFacturar, 10.1): activo desde el inicio y,
    // si el contrato está vencido pero sigue facturando (prórroga por estado activo), hasta el mes actual
    // — NO corta estricto en el fin del plazo firmado (antes: `primerDiaMes < fechaInicio+plazo`, que
    // dejaba la gestión de contratos vencidos-pero-activos fuera de Proyección aunque BRUTO sí la factura).
    // Offset por string (mismo conteo que getMesesAFacturar, sin corrimiento de timezone).
    const totalMeses = getMesesAFacturar(negocio.fecha_inicio, negocio.plazo_contrato_meses, negocio.estado);
    const [startYear, startMonth] = negocio.fecha_inicio.split("-").map((x) => parseInt(x, 10)); // startMonth 1-indexado

    for (let m = 0; m < 12; m++) {
      const offset = (ano - startYear) * 12 + (m + 1 - startMonth); // meses corridos desde el mes de inicio

      // Activo en este mes: dentro de la ventana [0, totalMeses) — inicio ≤ mes < inicio+prórroga.
      if (offset >= 0 && offset < totalMeses) {
        // Fecha para convertir UF/USD, MISMA prioridad que BRUTO cuando falta el registro de costos:
        // 1) costos_gestion_contenidos.fecha_factura (se preserva, sin cambio de comportamiento);
        // 2) meses_facturacion[gestion].facturafecha (misma fecha que useVFDataLoading);
        // 3) día 1 del mes (mismo fallback que BRUTO). NUNCA fin de mes como default fijo.
        const primerDiaMes = `${ano}-${String(m + 1).padStart(2, "0")}-01`;
        const fechaParaUF = getFechaFactura(m) || getFacturafechaMesesFact(negocio, "gestion", m, ano) || primerDiaMes;

        let ingresoLocal = 0;

        if (gestionUnitario > 0) {
          ingresoLocal += convertirAMonedaLocal(gestionUnitario * pantallas, negocio.moneda_gestion, pais, fechaParaUF);
        }

        if (contenidosUnitario > 0) {
          ingresoLocal += convertirAMonedaLocal(
            contenidosUnitario * pantallas,
            negocio.moneda_contenidos,
            pais,
            fechaParaUF
          );
        }

        mapa[m] += ingresoLocal;
      }
    }
  });

  return mapa;
};
